import React, { useContext } from 'react'
import "./home.scss";
import TopDashboard from '../../components/dashboard/TopDashboard';
import { AuthContext } from '../../context/AuthContext';

const Home = () => {
  const { admin } = useContext(AuthContext);

  const user = admin.role 


  return (
    <div className="main_wrp">
      <div className="dash_b_wrp">
        {user !== "admin" && <TopDashboard />}
      </div>
    </div>
  );
}

export default Home
